import { render, staticRenderFns } from "./JcdcCard.vue?vue&type=template&id=12cbf5ba"
import script from "./JcdcCard.vue?vue&type=script&lang=ts"
export * from "./JcdcCard.vue?vue&type=script&lang=ts"
import style0 from "./JcdcCard.vue?vue&type=style&index=0&id=12cbf5ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports